/// <reference types="vite/client" />

import type { LocationQuery, RouteParams } from 'vue-router'

export interface CopyStore {
  appTitle: string
  buttons: {
    [key: string]: string
  }
  termsLink: string
  privacyLink: string
  termsAndPrivacy: string
  supportLinks: {
    [key: string]: string
  }
}

export interface HostNames {
  [key: string]: string
}

export interface NavStore {
  isDropdownMenuOpen: boolean
  isMobile: boolean
  lastScrollTop: number
  managedFooter: object
}

export interface Modal {
  isOpen: boolean
}

export interface Login {
  differentPasswordMessage: string
  email: string
  emptyPasswordMessage: string
  existingUserMessage: string
  invalidEmailMessage: string
  sameEmailMessage: string
  invalidPasswordMessage: string
  isInvalidEmail: boolean
  matchingPasswordMessage: string
  password: string
  query: LocationQuery
  params: RouteParams
}
export interface AuthStore {
  token: string | null
  challengeId: string
}

export interface SelectOptionItem {
  value: string
  text: string
  disabled?: boolean
}

export interface InputPassword {
  disabled?: boolean
  hideRequirements?: boolean
  label?: string
  message?: string
  modelValue: string
  placeholder?: string
  required: boolean
  type?: string
  showAppend?: boolean
  showForgotPassword?: boolean
  validateInput?: () => void
  removeErrors?: () => void
  removeErrorsOnChange?: () => void
  setErrors?: () => void
  setErrorsOnChange?: () => void
}

export interface InputText {
  inputId: string
  keepErrorsVisible?: boolean
  label: string
  message?: string
  messageLinkText?: string
  modelValue: string
  placeholder?: string
  required?: boolean
  type?: string
  showAppend?: boolean
  validateInput?: () => void
  removeErrors?: () => void
  removeErrorsOnChange?: () => void
  setErrors?: () => void
  setErrorsOnChange?: () => void
}

export enum ViewName {
  Login = 'login',
  Success = 'success',
  Create = 'create'
}

export interface ViewDecorations {
  badgeText?: string
  title?: string
  body?: string
  viewName?: ViewName
  offerMessage?: string
  hideCreate?: boolean
  allowCreate?: boolean
}

export interface AppError {
  title?: string
  message?: string
}

export interface LoginResponse {
  apiKey: string
  refreshToken: string
}

export interface ErrorResponse {
  code?: string
  description?: string
  message?: string
  extensions?: { code?: string }
}

export enum AuthProductName {
  COPRODUCER = 'Coproducer',
  WEBSITE = 'Website'
}

export interface ProductConfig {
  id: string
  name: string
  viewDecorations: ViewDecorations[]
  authProductName: AuthProductName
  appReturnLinks?: Map<string, string>
  showYamahaSignIn?: boolean
}
